/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsIos } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsIos';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsIos';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay';

/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptions
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptions {
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    FacebookGames?: FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    FxId?: FxIdApplicationPublicDataBuilderPlatformDataOptionsFxId | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    VkontaktePlay?: FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    VkontakteCom?: FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteCom | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    Odnoklassniki?: FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassniki | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    Android?: FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroid | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsIos}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    Ios?: FxIdApplicationPublicDataBuilderPlatformDataOptionsIos | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    Windows?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    Web?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWeb | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptions
     */
    Steam?: FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam | null;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptions(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptions {
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'FacebookGames': json['FacebookGames'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSON(json['FacebookGames']),
        'FxId': json['FxId'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdFromJSON(json['FxId']),
        'VkontaktePlay': json['VkontaktePlay'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSON(json['VkontaktePlay']),
        'VkontakteCom': json['VkontakteCom'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComFromJSON(json['VkontakteCom']),
        'Odnoklassniki': json['Odnoklassniki'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiFromJSON(json['Odnoklassniki']),
        'Android': json['Android'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidFromJSON(json['Android']),
        'Ios': json['Ios'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsIosFromJSON(json['Ios']),
        'Windows': json['Windows'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSON(json['Windows']),
        'Web': json['Web'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsWebFromJSON(json['Web']),
        'Steam': json['Steam'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSON(json['Steam']),
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'FacebookGames': FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSON(value['FacebookGames']),
        'FxId': FxIdApplicationPublicDataBuilderPlatformDataOptionsFxIdToJSON(value['FxId']),
        'VkontaktePlay': FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSON(value['VkontaktePlay']),
        'VkontakteCom': FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontakteComToJSON(value['VkontakteCom']),
        'Odnoklassniki': FxIdApplicationPublicDataBuilderPlatformDataOptionsOdnoklassnikiToJSON(value['Odnoklassniki']),
        'Android': FxIdApplicationPublicDataBuilderPlatformDataOptionsAndroidToJSON(value['Android']),
        'Ios': FxIdApplicationPublicDataBuilderPlatformDataOptionsIosToJSON(value['Ios']),
        'Windows': FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSON(value['Windows']),
        'Web': FxIdApplicationPublicDataBuilderPlatformDataOptionsWebToJSON(value['Web']),
        'Steam': FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSON(value['Steam']),
    };
}

